// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
import { updateVisualization } from "./updateVisualization";
export function setupPyodideContext(vss, molstar, pyodide, closeSystemPanels, removeVisibleSystemsFiles) {
    return __awaiter(this, void 0, void 0, function* () {
        const updateVisualizationQueue = [];
        let isUpdatingVisualization = false;
        function processUpdateVisualizationQueue() {
            return __awaiter(this, void 0, void 0, function* () {
                if (isUpdatingVisualization)
                    return;
                isUpdatingVisualization = true;
                while (updateVisualizationQueue.length > 0) {
                    const { molId, update } = updateVisualizationQueue.shift();
                    yield updateVisualization(molId, update, molstar, pyodide, vss, closeSystemPanels, removeVisibleSystemsFiles);
                }
                isUpdatingVisualization = false;
            });
        }
        // Define get_system
        const update_pyodide_systemtree = () => {
            const updatedSystemsTree = vss.getState().loaded_structures;
            pyodide.RunPythonAsync({
                context: { updatedSystemsTree },
                script: `
      from js import updatedSystemsTree
      systems_tree = updatedSystemsTree.to_py()
      `,
            });
        };
        const check_viz_change = () => __awaiter(this, void 0, void 0, function* () {
            var _a, e_1, _b, _c, _d, e_2, _e, _f;
            const updates = yield pyodide.RunPythonAsync({
                context: {},
                script: `
      tmp_updated_mol_reps = copy.deepcopy(updated_mol_reps)
      updated_mol_reps={} 
      tmp_updated_mol_reps
      `,
            });
            if (updates && Object.keys(updates).length > 0) {
                try {
                    for (var _g = true, _h = __asyncValues(Object.keys(updates)), _j; _j = yield _h.next(), _a = _j.done, !_a;) {
                        _c = _j.value;
                        _g = false;
                        try {
                            const molId = _c;
                            const molUpdates = updates[molId];
                            try {
                                for (var _k = true, molUpdates_1 = (e_2 = void 0, __asyncValues(molUpdates)), molUpdates_1_1; molUpdates_1_1 = yield molUpdates_1.next(), _d = molUpdates_1_1.done, !_d;) {
                                    _f = molUpdates_1_1.value;
                                    _k = false;
                                    try {
                                        const update = _f;
                                        updateVisualizationQueue.push({ molId, update });
                                    }
                                    finally {
                                        _k = true;
                                    }
                                }
                            }
                            catch (e_2_1) { e_2 = { error: e_2_1 }; }
                            finally {
                                try {
                                    if (!_k && !_d && (_e = molUpdates_1.return)) yield _e.call(molUpdates_1);
                                }
                                finally { if (e_2) throw e_2.error; }
                            }
                        }
                        finally {
                            _g = true;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (!_g && !_a && (_b = _h.return)) yield _b.call(_h);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            yield processUpdateVisualizationQueue();
        });
        const check_system_change = () => __awaiter(this, void 0, void 0, function* () {
            const updates = yield pyodide.RunPythonAsync({
                context: {},
                script: `
      molecule_updates = []
      try:
        molecule_updates = monitor.is_changed(systems)
      except NameError:
        pass
      molecule_updates
      `,
            });
            const changedMolecules = updates[0];
            const emptyMolecules = updates[1];
            const addedMolecules = updates[2];
            for (const moleculeID of changedMolecules) {
                updateVisualizationQueue.push({
                    molId: moleculeID,
                    update: { action: "syst_update" },
                });
            }
            for (const moleculeID of addedMolecules) {
                updateVisualizationQueue.push({
                    molId: moleculeID,
                    update: { action: "syst_add" },
                });
            }
            for (const moleculeID of emptyMolecules) {
                updateVisualizationQueue.push({
                    molId: moleculeID,
                    update: { action: "syst_remove", data: true },
                });
            }
            yield processUpdateVisualizationQueue();
        });
        // Periodically check for updates in molkit molecules
        setInterval(() => {
            update_pyodide_systemtree();
            check_system_change();
            check_viz_change();
        }, 300);
    });
}
